import React from 'react';
import Lightbox from '../../../../../components/shared/Lightbox';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const FullscreenTrailDetailsFrame = createReactClass({
  getInitialState() {
    return {
      iFrameLoaded: false,
      images: [],
      isOpen: false,
      startingIndex: null,
      trailId: null
    };
  },
  componentDidMount() {
    window.document.addEventListener('toggleModal', this.handleToggleModal);

    document.getElementById('trail-details-frame').onload = function() {
      this.setState({ iFrameLoaded: true });
      document.getElementById('trail-details-frame').focus();
    }.bind(this);
  },
  handleToggleModal(data) {
    const { images, isOpen, startingIndex, trailId } = data.detail;
    this.setState({ images, isOpen, startingIndex, trailId });
  },
  handleCloseRequest() {
    this.setState({ isOpen: false, images: [], startingIndex: null, trailId: null });
  },
  renderImageLightbox() {
    if (!this.state.isOpen) {
      return;
    }

    return (
      <Lightbox
        images={this.state.images}
        handleCloseRequest={this.handleCloseRequest}
        isOpen={this.state.isOpen}
        startingIndex={this.state.startingIndex}
        trailId={this.state.trailId}
      />
    );
  },
  render() {
    const iFrameStyle = {
      display: 'block',
      visibility: 'hidden',
      height: '100%',
      width: 1,
      minWidth: '100%',
      bottom: 0,
      left: 0
    };
    if (this.props.isMobileWidth) iFrameStyle.width = '100%';
    if (this.state.iFrameLoaded) {
      iFrameStyle.visibility = 'visible';
    }
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div id="iframe-loading" style={{ display: this.state.iFrameLoaded ? 'none' : 'block' }}>
          <div className="header">{StringConstantsMixin.strings.SEARCH.TRAIL_LOAD_INFO}</div>
          <div className="icon trailpost">
            <span className="icon-text">{StringConstantsMixin.strings.SEARCH.TRAIL_LOAD_MSG}</span>
          </div>
        </div>
        <iframe id="trail-details-frame" src={this.props.src} style={iFrameStyle} scrolling="no" />
        {this.renderImageLightbox()}
      </div>
    );
  }
});

export { FullscreenTrailDetailsFrame };
